/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Issue_Too_LongInputs */

const en_issue_too_long = /** @type {(inputs: Issue_Too_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`longer than the column of the file to the ERP holds`)
};

/**
* | output |
* | --- |
* | "longer than the column of the file to the ERP holds" |
*
* @param {Issue_Too_LongInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const issue_too_long = /** @type {((inputs?: Issue_Too_LongInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issue_Too_LongInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_issue_too_long(inputs)
});